import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import RsvpSettings from '../../libs/component-rsvp-settings';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import FullScreenModal from '~/glm/containers/full-screen-modal';
import AnalyticsStore from '~/glm/models/analytics-store';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import GuestListStore from '~/glm/models/guest-list-store';
import UserStore from '~/glm/models/user-store';
import { withRouter } from 'react-router-dom';

@withRouter
@inject('gdsUiState', 'gdsEvents', 'gdsHouseholds', 'userStore', 'guestListStore', 'analyticsStore')
@observer
class RSVPSettingsPage extends Component {
  static propTypes = {
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection).isRequired,
    userStore: PropTypes.instanceOf(UserStore),
    guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  };

  state = {
    saved: false,
  };

  componentDidMount() {
    const { gdsEvents, analyticsStore, guestListStore } = this.props;
    const rsvpPreference = get(guestListStore, ['guestWedding', 'isPrivateRsvp']) ? 'secure' : 'public';

    const events = gdsEvents.map(e => {
      e.meals = e.mealQuestion && e.mealQuestion.options;
      return { ...e, meals: e.mealQuestion && e.mealQuestion.options };
    });

    this.setState({ events });

    analyticsStore.track('RSVP Settings Interaction', {
      action: 'modal loaded',
      rsvpPreference,
      security: 'private',
      source: 'guest list',
    });
  }

  onSuccess = updatedWedding => {
    const { guestListStore, analyticsStore } = this.props;
    const wasAllowGuestPreviewChanged =
      get(guestListStore, ['guestWedding', 'allowGuestPreview']) !== updatedWedding.allowGuestPreview;
    const action = wasAllowGuestPreviewChanged
      ? `${updatedWedding.allowGuestPreview ? 'enable' : 'disable'} public RSVP list`
      : 'save';

    guestListStore.guestWedding.setProps(updatedWedding);
    analyticsStore.track('RSVP Settings Interaction', {
      action,
      security: 'private',
      source: 'guest list',
    });
    this.setState({ saved: true });
  };

  onCancel = () => {
    const { analyticsStore, guestListStore, history } = this.props;
    const { saved } = this.state;

    if (saved === false) {
      analyticsStore.track('RSVP Settings Interaction', {
        action: 'cancel',
        rsvpPreference: get(guestListStore, ['guestWedding', 'isPrivateRsvp']) ? 'secure' : 'public',
        security: 'private',
        source: 'guest list',
      });
    }
    history.push('/our-guest-list');
  };

  onEventsUpdate = updatedEvents => {
    const { gdsEvents } = this.props;

    updatedEvents.forEach(updatedEvent => {
      let event = gdsEvents.get(updatedEvent.id);

      if (event) {
        if (updatedEvent.questions) {
          event.setCustomQuestions(updatedEvent.questions);
          delete updatedEvent.questions;
        } else if (event.getCustomQuestions && !updatedEvent.questions) {
          // Clear out the questions if they were deleted
          event.setCustomQuestions(null);
        }
        event.setProps(updatedEvent);
      } else {
        const params = {
          ...updatedEvent,
          fullAddress: { ...updatedEvent.location },
          locationName: get(updatedEvent, ['location', 'name']),
        };
        const newEvent = new GdsEventModel(params);
        gdsEvents.add(newEvent);
      }
    });
  };

  openEventModal = eventID => {
    const { gdsUiState, gdsEvents } = this.props;
    gdsUiState.setShowEventModal(true);
    gdsUiState.setSelectedEvent(gdsEvents.get(eventID));
    gdsUiState.setRsvpModalView(false);
  };

  goToGuestList = eventID => {
    const { gdsUiState, gdsEvents } = this.props;
    gdsUiState.setSelectedEvent(gdsEvents.get(eventID));
    gdsUiState.setRsvpModalView(false);
  };

  render() {
    const { guestListStore, gdsHouseholds, gdsEvents, userStore } = this.props;

    const events = gdsEvents.nonReceptionEvents.map(e => {
      return {
        id: e.id,
        weddingId: e.weddingId,
        name: e.name,
        type: e.type,
        date: e.date,
        time: e.time,
        requireRsvp: e.requireRsvp,
        endTime: e.endTime,
        location: e.location,
        attire: e.attire,
        notes: e.notes,
        visible: e.visible,
        subEvents: e.subEvents,
        image: e.image,
        locationUpdatedAt: e.locationUpdatedAt,
        questions: e.getCustomQuestions(),
        guestCount: e.guestCount,
      };
    });

    return (
      <FullScreenModal>
        <RsvpSettings
          guestWedding={guestListStore.guestWedding}
          events={events}
          households={gdsHouseholds.values()}
          isPrivateRsvp={guestListStore.guestWedding.isPrivateRsvp}
          onSuccess={this.onSuccess}
          onEventsUpdate={this.onEventsUpdate}
          onCancelClick={this.onCancel}
          openEventModal={this.openEventModal}
          goToGuestList={this.goToGuestList}
          wwsState={userStore.wedding.state}
        />
      </FullScreenModal>
    );
  }
}

export default RSVPSettingsPage;
